import Basket from "./basket";

$(document).ready(() => {
	if (jQuery('.shop-cart_item_materials')) {
		new Basket();
	}
});
